import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { PipelinesPaths } from 'app/configs/routesConfig/pipelines';
import Skeleton from 'app/shared/components/common/Skeleton';

// Concrete-module import (not the store/companies/selectors barrel): this HOC is pulled
// in by routesConfig/crm.js, and the barrel's transitive graph reaches navigationConfig,
// which imports routesConfig/crm.js back — the cycle leaves CrmPaths undefined mid-init.
import {
  selectAreMasterCompanyPropertiesSettled,
  selectIsCrmEnabledForCompany,
} from 'store/companies/selectors/crmFeatures.selectors';

/**
 * Route guard for the CRM area: a company that opted out with EnableCrm=false must not
 * reach the CRM surfaces through a bookmark or a typed URL once the nav entry is hidden.
 * Redirects to the pipelines home after the company properties settle; renders a
 * skeleton while they load so the page never flashes for a disabled company.
 *
 * The lead-workspace route is NOT wrapped — LeadWorkspacePage owns a smarter redirect
 * that keeps the specific application (bounces to its loan editor).
 */
const withCrmCompanyGate = WrappedComponent => {
  const EnhancedComponent = props => {
    const isCrmEnabledForCompany = useSelector(selectIsCrmEnabledForCompany);
    const areMasterCompanyPropertiesSettled = useSelector(selectAreMasterCompanyPropertiesSettled);

    if (!areMasterCompanyPropertiesSettled) {
      return <Skeleton />;
    }

    if (!isCrmEnabledForCompany) {
      return <Redirect to={PipelinesPaths.loanPipelines.generatePath()} />;
    }

    return <WrappedComponent {...props} />;
  };

  return EnhancedComponent;
};

export default withCrmCompanyGate;
